import split from "./split-calculator";

const SplitCalculator = {
  split
};

export default SplitCalculator;
